import * as React from 'react'
import { Link } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const Actions: React.FC<{ targetId: number; reviewId: number }> = ({
  targetId,
  reviewId,
}) => {
  const { navigation } = useNavigation()

  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      <Link
        to={navigation.performanceProcess.reviews.review.target.fullPath({
          reviewId: reviewId,
          targetId: reviewId + '-' + targetId,
        })}
      >
        <Button type="secondary" aria-label="Access review" iconName="arrow-right" />
      </Link>
    </Box>
  )
}
